import React from "react";

const ScoreFlavorContext = React.createContext({
  scoreFlavor: null,
  setScoreFlavor: () => {},
});

export { ScoreFlavorContext };
